import { render, staticRenderFns } from "./FormAuther.vue?vue&type=template&id=58d84b3e&scoped=true"
import script from "./FormAuther.vue?vue&type=script&lang=js"
export * from "./FormAuther.vue?vue&type=script&lang=js"
import style0 from "./FormAuther.vue?vue&type=style&index=0&id=58d84b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d84b3e",
  null
  
)

export default component.exports